import * as MuiDatePicker from '@mui/x-date-pickers'
import { DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker'
// import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker'
import { ReactNode, forwardRef } from 'react'

export type DatePickerProps<TDate> = MuiDatePickerProps<TDate> & {
  children?: ReactNode
}

export const DatePicker = forwardRef(
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props: DatePickerProps<any>,
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined,
  ) => <MuiDatePicker.DesktopDatePicker {...props} ref={ref} />,
  // ) => <MuiDatePicker.DesktopDatePicker {...props} ref={ref} />,
)
